import { Modal } from "bootstrap";

import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import {
    useForm,
} from "react-hook-form";

import { toast } from "react-toastify";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

const B2BActivityMettingUpdateModal = forwardRef(
    (props, ref) => {

        const {
            leadDetails,
            getLeadData,
            getLeadFollowup,
        } = props;

        const {
            register,
            handleSubmit,
            reset,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });

        const modalRef = useRef(null);

        const bsModal = useRef(null);

        const [submitLoader, setSubmitLoader] =
            useState(false);

        // =========================================
        // CLOSE MODAL
        // =========================================

        const handleClose = () => {

            reset();

            bsModal.current?.hide();

        };

        // =========================================
        // MODAL HANDLE
        // =========================================

        useImperativeHandle(ref, () => ({

            toggle() {

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

            },

            close() {

                handleClose();

            },

        }));

        // =========================================
        // SUBMIT
        // =========================================

        const onSubmit = async (
            data
        ) => {

            setSubmitLoader(true);

            try {

                const formData =
                    new FormData();

                formData.append(
                    "meetingDate",
                    data?.meetingDate || ""
                );

                formData.append(
                    "meetingTime",
                    data?.meetingTime || ""
                );

                formData.append(
                    "meetingType",
                    data?.meetingType || ""
                );

                formData.append(
                    "meetingVenue",
                    data?.meetingVenue || ""
                );

                formData.append(
                    "occuranceType",
                    data?.occuranceType || ""
                );

                const leadId =
                    leadDetails?.id;

                const res =
                    await b2bleadService.meetingUpdate(
                        leadId,
                        formData
                    );

                if (
                    res?.data?.status ===
                    "success"
                ) {

                    toast.success(
                        res?.data?.message ||
                        "Meeting updated successfully"
                    );

                    handleClose();

                    getLeadData?.();

                    getLeadFollowup?.();

                } else {

                    toast.error(
                        res?.data?.message ||
                        "Failed to update meeting"
                    );

                }

            } catch (error) {

                console.log(
                    "MEETING UPDATE ERROR",
                    error
                );

                toast.error(
                    error?.response?.data
                        ?.message ||
                    "Failed to update meeting"
                );

            } finally {

                setSubmitLoader(false);

            }

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4 overflow-hidden">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >

                            <div>

                                {/* <h5 className="modal-title fw-bold mb-1">
                                    Meeting Update
                                </h5> */}

                                <p className="mb-0 small opacity-75">
                                    Schedule or complete a meeting activity
                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* MEETING DATE */}
                                    <div className="col-md-6">

                                        <label className="form-label fw-semibold">

                                            Meeting Date

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <input
                                            type="date"
                                            className={`form-control ${
                                                errors.meetingDate
                                                    ? "is-invalid"
                                                    : ""
                                            }`}
                                            {...register(
                                                "meetingDate",
                                                {
                                                    required:
                                                        "Meeting date is required",
                                                }
                                            )}
                                        />

                                        {errors.meetingDate && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .meetingDate
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                    {/* MEETING TIME */}
                                    <div className="col-md-6">

                                        <label className="form-label fw-semibold">

                                            Meeting Time

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <input
                                            type="time"
                                            className={`form-control ${
                                                errors.meetingTime
                                                    ? "is-invalid"
                                                    : ""
                                            }`}
                                            {...register(
                                                "meetingTime",
                                                {
                                                    required:
                                                        "Meeting time is required",
                                                }
                                            )}
                                        />

                                        {errors.meetingTime && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .meetingTime
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                    {/* MEETING TYPE */}
                                    <div className="col-md-6">

                                        <label className="form-label fw-semibold">

                                            Meeting Type

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <select
                                            className={`form-select ${
                                                errors.meetingType
                                                    ? "is-invalid"
                                                    : ""
                                            }`}
                                            {...register(
                                                "meetingType",
                                                {
                                                    required:
                                                        "Meeting type is required",
                                                }
                                            )}
                                        >

                                            <option value="">
                                                Select
                                            </option>

                                            <option value="online">
                                                Online
                                            </option>

                                            <option value="offline">
                                                Offline
                                            </option>

                                        </select>

                                        {errors.meetingType && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .meetingType
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                    {/* MEETING VENUE */}
                                    <div className="col-md-6">

                                        <label className="form-label fw-semibold">

                                            Meeting Venue

                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter meeting venue"
                                            {...register(
                                                "meetingVenue"
                                            )}
                                        />

                                    </div>

                                    {/* OCCURANCE TYPE */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold d-block mb-3">

                                            Activity Status

                                        </label>

                                        <div className="d-flex gap-4 flex-wrap">

                                            <div className="form-check">

                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    value="scheduled"
                                                    id="scheduled"
                                                    {...register(
                                                        "occuranceType",
                                                        {
                                                            required:
                                                                "Please select activity status",
                                                        }
                                                    )}
                                                />

                                                <label
                                                    className="form-check-label"
                                                    htmlFor="scheduled"
                                                >

                                                    Schedule the Activity

                                                </label>

                                            </div>

                                            <div className="form-check">

                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    value="done"
                                                    id="done"
                                                    {...register(
                                                        "occuranceType",
                                                        {
                                                            required:
                                                                "Please select activity status",
                                                        }
                                                    )}
                                                />

                                                <label
                                                    className="form-check-label"
                                                    htmlFor="done"
                                                >

                                                    Mark as Done

                                                </label>

                                            </div>

                                        </div>

                                        {errors.occuranceType && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .occuranceType
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        submitLoader
                                    }
                                >

                                    {submitLoader
                                        ? "Updating..."
                                        : "Update Meeting"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        );

    }
);

export default B2BActivityMettingUpdateModal;